/**
 * Convertit le polygone d'une zone (format Secteurs) en coordonnées Leaflet [lat, lng].
 */
export function parseZonePolygon(polygon) {
  if (!polygon) return null;

  let data = polygon;
  if (typeof polygon === 'string') {
    try {
      data = JSON.parse(polygon);
    } catch {
      return null;
    }
  }

  if (!Array.isArray(data) || data.length === 0) return null;

  const ring = Array.isArray(data[0]) && Array.isArray(data[0][0]) ? data[0] : data;

  const coords = ring
    .map((point) => {
      if (!Array.isArray(point) || point.length < 2) return null;
      const lng = Number(point[0]);
      const lat = Number(point[1]);
      if (Number.isNaN(lng) || Number.isNaN(lat)) return null;
      // BDD Secteurs / GeoJSON : [lng, lat] → Leaflet : [lat, lng]
      return [lat, lng];
    })
    .filter(Boolean);

  return coords.length >= 3 ? coords : null;
}

/** Convertit des coordonnées Leaflet [lat,lng] vers le format API [[[lng,lat],...]] */
export function leafletCoordsToPolygon(coords) {
  if (!coords?.length) return [];
  const ring = coords.map(([lat, lng]) => [lng, lat]);
  return [ring];
}

/** Calcule le centre [lng, lat] depuis des coordonnées Leaflet */
export function computePolygonCentre(coords) {
  if (!coords?.length) return [0, 0];
  let latSum = 0;
  let lngSum = 0;
  coords.forEach(([lat, lng]) => {
    latSum += lat;
    lngSum += lng;
  });
  return [lngSum / coords.length, latSum / coords.length];
}

export function formatCa(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (Number.isNaN(n)) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)} M€`;
  if (n >= 1_000) return `${Math.round(n / 1_000)} k€`;
  return `${n} €`;
}

/** Ray casting : point [lat, lng] dans un polygone Leaflet [[lat,lng],...] */
export function isPointInPolygon(lat, lng, polygonCoords) {
  if (!polygonCoords?.length) return false;
  let inside = false;
  const x = lng;
  const y = lat;
  for (let i = 0, j = polygonCoords.length - 1; i < polygonCoords.length; j = i++) {
    const [yi, xi] = polygonCoords[i];
    const [yj, xj] = polygonCoords[j];
    const intersect = (yi > y) !== (yj > y) && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

export function isPointInAnyZone(lat, lng, zones) {
  if (!zones?.length) return true;
  return zones.some((zone) => {
    const coords = parseZonePolygon(zone.polygon);
    return coords && isPointInPolygon(lat, lng, coords);
  });
}

export async function geocodeAdresse(query) {
  const url = `https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(query)}&lat=46.9852&lon=3.1598`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Géocodage indisponible');
  }
  return response.json();
}
